import pattern from '../../assets/home/pattern.webp';

// The Sundanese batik motif, used as a faint corner accent to tie sections
// together. Always decorative: aria-hidden, pointer-events-none, and behind
// the content, so it can never intercept a click or reach a screen reader.
//
// `at` picks the corner it bleeds from; opacity stays low by default because
// the motif is dense and competes with body text well before it looks bold.
const CORNERS = {
  'bottom-right': '-bottom-10 -right-10',
  'top-right': '-top-12 -right-12',
  'bottom-left': '-bottom-10 -left-10',
  'top-left': '-top-12 -left-12',
};

export default function PatternAccent({
  at = 'bottom-right', className = 'w-52', opacity = 0.13, flip = false,
}) {
  return (
    <img
      src={pattern}
      alt=""
      aria-hidden="true"
      style={{ opacity }}
      className={`pointer-events-none absolute z-0 select-none ${CORNERS[at] || CORNERS['bottom-right']} ${flip ? 'scale-x-[-1]' : ''} ${className}`}
    />
  );
}
